export enum AdUnitRPSGuarantee {
  None,
  Core,
  Excluded,
  Other
}